import {
  FunderView_Bool_Exp,
  PlanterView_Bool_Exp
} from 'src/config/generated/graphql'

export function buildLeaderboardWhere({
  searchQuery,
  onlyApproved = false
}: {
  searchQuery?: string
  onlyApproved?: boolean
}) {
  let where: PlanterView_Bool_Exp | FunderView_Bool_Exp = {}

  if (onlyApproved) {
    where = { ...where, TotalTreesApproved: { _gt: 0 } }
  }

  if (searchQuery) {
    const ilikeQuery = `%${searchQuery}%`

    where = {
      ...where,
      _or: [
        { Name: { _ilike: ilikeQuery } },
        { AccountName: { _ilike: ilikeQuery } }
      ]
    }
  }

  return where
}
